import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import Input from "../../../../../components/main/input";
import Button from "../../../../../components/main/button";
import fetch from "../../../../../utils/fetch";

interface Props {}

const Password: React.FC<Props> = () => {
    const [currentPassword, setCurrentPassword] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [restartPasswords, setRestartPasswords] = useState(0);
    const [buttonActive, setButtonActive] = useState({ password: false });

    const update = () => {
        setButtonActive({ ...buttonActive, password: true });
        const post = new fetch("/auth/update-password", { password: currentPassword, new_password: password, confirm_password: confirmPassword }, { success: true, error: true }).post();

        post.then((res) => {
            if (res.status === "success") {
                setCurrentPassword("");
                setPassword("");
                setConfirmPassword("");
                setRestartPasswords(restartPasswords + 1);
            }
            setButtonActive({ ...buttonActive, password: false });
        }).catch(() => {
            setButtonActive({ ...buttonActive, password: false });
        });
    };

    return (
        <>
            <Input
                className="input-small"
                type="password"
                name="password"
                placeholder="Current password"
                focusOut={(value) => {
                    setCurrentPassword(value);
                }}
                changeDefault={restartPasswords}
                defaultValue=""
            />
            <Input
                className="input-small"
                type="password"
                name="password"
                placeholder="New password"
                focusOut={(value) => {
                    setPassword(value);
                }}
                changeDefault={restartPasswords}
                defaultValue=""
            />
            <div>
                <small>Password requires at least 1 number and upper case character.</small>
            </div>
            <Input
                className="input-small"
                type="password"
                name="confirmPassword"
                placeholder="Confirm new password"
                focusOut={(value) => {
                    setConfirmPassword(value);
                }}
                changeDefault={restartPasswords}
                defaultValue=""
            />
            <div className="text-right">
                <Button
                    active={buttonActive.password}
                    color="blue"
                    value="Update Password"
                    onClick={() => {
                        update();
                    }}
                ></Button>
            </div>
        </>
    );
};

export default Password;
